var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"dashboard"},[_vm._v("OAuth")]),_c('SpinnerLoader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }